export default [
  {
    path: '/',
    meta: { authRequired: false },
    component: () => import('./views/dashboards/default'),
    children: [
      {
        path: '',
        meta: { authRequired: false },
        component: () => import('./views/dashboards/home/home'),
        children: [
          // {
          //   path: '',
          //   name: 'Default',
          //   meta: { authRequired: false },
          //   component: () => import('./views/dashboards/home/public'),
          // },
          {
            path: 'public',
            name: 'Public Search',
            meta: { authRequired: false },
            component: () => import('./views/dashboards/home/public'),
          },
          {
            path: 'public-search/category/:cid?',
            name: 'Public Search Category',
            meta: { authRequired: false },
            component: () => import('./views/dashboards/home/public'),
          },
          {
            path: 'public-search/campus/:cmpid?',
            name: 'Public Search Campus',
            meta: { authRequired: false },
            component: () => import('./views/dashboards/home/public'),
          }
        ]
      }
    ]
  },
  {
    path: '/document-request',
    name: 'Document Request',
    meta: { authRequired: false },
    component: () => import('./views/dashboards/public-request/document-request')
  },
  {
    path: '/document-request-status',
    name: 'Document Request Status',
    meta: { authRequired: false },
    component: () => import('./views/dashboards/public-request/document-status')
  },
  {
    path: '/user-profile',
    name: 'User Profile',
    meta: { authRequired: true },
    component: () => import('./views/profile/user-profile')
  },
  {
    path: '/notifications',
    name: 'Notifications',
    meta: { authRequired: true },
    component: () => import('./views/notifications/notifications'),
  },
  {
    path: '/du-archive',
    meta: { authRequired: true },
    component: () => import('./views/dashboards/dashboard'),
    redirect: { name: 'Archive' },
    children: [
      { 
        path: '/archive-master',
        name: 'Archive',
        meta: { authRequired: true },
        component: () => import('./views/dashboards/display-layout'),
        redirect: { name: 'My Folder' },
        children: [
          {
            path: 'my-office', // careful to change this naay variable path na nag base ani
            name: 'My Folder',
            meta: { authRequired: true },
            component: () => import('./views/file-manager/my-folder'),
          },
          {
            path: 'folders/:id',
            name: 'Folder ID',
            meta: { authRequired: true },
            sensitive: true,
            component: () => import('./views/file-manager/file-manager'),
          },
          {
            path: 'shared-with-me',
            name: 'Shared with Me',
            meta: { authRequired: true },
            component: () => import('./views/file-manager/shared-with-me/shared-with-me'),
          },
          {
            path: 'pin',
            name: 'Pin',
            meta: { authRequired: true },
            component: () => import('./views/file-manager/pin/pin'),
          },
          {
            path: 'trash',
            name: 'Trash',
            meta: { authRequired: true },
            component: () => import('./views/file-manager/trash/trash'),
          },
          {
            path: 'smart-upload',
            name: 'Smart Upload',
            meta: { authRequired: true },
            component: () => import('./views/file-manager/smart-upload/smart-upload'),
          },
          {
            path: 'advanced-search/:type/:cid?',
            name: 'Advanced Search',
            meta: { authRequired: true },
            component: () => import('./views/file-manager/search/advanced-search'),
          },
          {
            path: 'my-location',
            name: 'My Location',
            meta: { authRequired: true },
            component: () => import('./views/file-location-manager/my-location'),
          },
          {
            path: 'locations/:id',
            name: 'Location ID',
            meta: { authRequired: true },
            sensitive: true,
            component: () => import('./views/file-location-manager/file-location-manager'),
          },
          {
            path: 'my-submissions',
            name: 'My Archive',
            meta: { authRequired: true },
            component: () => import('./views/file-posting/du/post'),
          },
          {
            path: 'request',
            name: 'Archive Request',
            meta: { authRequired: true },
            component: () => import('./views/file-archive/request/request'),
          },
          {
            path: 'pending-approvals',
            name: 'Admin File Posting',
            meta: { authRequired: true },
            component: () => import('./views/file-posting/admin/post'),
          },
          {
            path: 'files-by-category',
            name: 'Search By Category',
            meta: { authRequired: true },
            component: () => import('./views/file-manager/search/by-category'),
          },
          {
            path: 'files-by-category-v2',
            name: 'Search By Category V2',
            meta: { authRequired: true },
            component: () => import('./views/file-manager/search/by-category-v2'),
          },
          {
            path: 'office-archive/public',
            name: 'Office Archive Dashboard',
            meta: { authRequired: true },
            component: () => import('./views/file-archive/my-public-files-dashboard'),
          },
          {
            path: 'office-records',
            name: 'Office Archive',
            meta: { authRequired: true },
            component: () => import('./views/file-archive/my-public-files'),
          },
          // {
          //   path: 'file-pool',
          //   name: 'File Pool',
          //   meta: { authRequired: true },
          //   component: () => import('./views/pool/pool'),
          // },
          {
            path: 'my-pool',
            name: 'My Pool',
            meta: { authRequired: true },
            component: () => import('./views/pool/my-pool'),
          },
          // {
          //   path: 'my-pool-user',
          //   name: 'My Pool User',
          //   meta: { authRequired: true },
          //   component: () => import('./views/pool/my-pool-user'),
          // },
          {
            path: 'pool-shared-with-me',
            name: 'Pool Shared with Me',
            meta: { authRequired: true },
            component: () => import('./views/pool/shared-with-me'),
          },
          {
            path: 'pool/link/:token',
            name: 'Pool Link',
            meta: { authRequired: true },
            component: () => import('./views/pool/pool-link'),
            props: true,
          },
          {
            path: 'pool/:id',
            name: 'Pool ID',
            meta: { authRequired: true },
            component: () => import('./views/pool/pool-files'),
            props: true,
          },
          {
            path: 'freedom-of-information/public-request',
            name: 'Public Request',
            meta: { authRequired: true },
            component: () => import('./views/freedom-of-information/public-request'),
          },
          {
            path: 'cru-expire-document',
            name: 'Expire Document',
            meta: { authRequired: true },
            component: () => import('./views/file-settings/expire/expire'),
          },
          {
            path: 'document-category',
            name: 'Document Category',
            meta: { authRequired: true },
            component: () => import('./views/file-settings/document/category')
          },
          {
            path: 'document-tag',
            name: 'Document Tag',
            meta: { authRequired: true },
            component: () => import('./views/file-settings/document/tag')
          }
        ]
      },
      {
        path: '/campus',
        name: 'Campus',
        meta: { authRequired: true },
        component: () => import('./views/campus/campus'),
      },
      {
        path: '/campus/du/:id',
        name: 'Office ID',
        meta: { authRequired: true },
        sensitive: true,
        component: () => import('./views/campus/office/office'),
      }
    ]
  },
  {
    path: '/admin',
    meta: { authRequired: true },
    component: () => import('./views/admin/admin-menu'),
    children: [
      {
        path: '',
        name: 'Admin Dashboard',
        meta: { authRequired: true },
        component: () => import('./views/admin/dashboard/admin-dashboard')
      },
      {
        path: 'admin-document-category',
        name: 'Admin Document Category',
        meta: { authRequired: true },
        component: () => import('./views/admin/document/category/category')
      },
      {
        path: 'document-tag',
        name: 'Admin Document Tag',
        meta: { authRequired: true },
        component: () => import('./views/admin/document/tag/tag')
      },
      {
        path: 'settings-campus',
        name: 'Settings Campus',
        meta: { authRequired: true },
        component: () => import('./views/admin/setting/campus/campus')
      },
      {
        path: 'settings-office',
        name: 'Settings Office',
        meta: { authRequired: true },
        component: () => import('./views/admin/setting/office/office')
      },
      {
        path: 'settings-delivery-unit',
        name: 'Settings Delivery Unit',
        meta: { authRequired: true },
        component: () => import('./views/admin/setting/delivery-unit/delivery-unit')
      },
      {
        path: 'user-request',
        name: 'User Request',
        meta: { authRequired: true },
        component: () => import('./views/admin/user/user-request')
      },
      {
        path: 'user-all',
        name: 'User All',
        meta: { authRequired: true },
        component: () => import('./views/admin/user/user-all')
      },
      {
        path: 'document-access-level',
        name: 'Access Level',
        meta: { authRequired: true },
        component: () => import('./views/admin/document/access-level/access-level')
      },
      {
        path: 'user-approver',
        name: 'User Approver',
        meta: { authRequired: true },
        component: () => import('./views/admin/user/user-approver')
      },
      {
        path: 'developer/system-information',
        name: 'System Information',
        meta: { authRequired: true },
        component: () => import('./views/admin/developer/system-information')
      }
    ],
  },
  {
    path: '/login',
    name: 'Login',
    meta: { isGuest: true },
    component: () => import('./views/account/login'),
  },
  {
    path: '/register',
    name: 'Register',
    meta: { isGuest: true },
    component: () => import('./views/account/register'),
  },
  {
    path: '/forgot-password',
    name: 'Forgot Password',
    meta: { isGuest: true },
    component: () => import('./views/account/forgot-password'),
  },
  {
    path: '/reset-password',
    name: 'Reset Password',
    meta: { isGuest: true },
    component: () => import('./views/account/reset-password'),
  },
  {
    path: '/email-verification/:email',
    name: 'Email Verification',
    meta: { isGuest: true },
    component: () => import('./views/account/email-verification'),
  },
  {
    path: '/files/:id',
    name: 'File Preview',
    sensitive: true,
    component: () => import('./views/public/public-viewer'),
  },
  {
    path: '/folder/data/:id',
    name: 'Location Files',
    sensitive: true,
    component: () => import('./views/public/public-file-location'),
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]
